import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
// import CSSModules from 'react-css-modules'
// import Loader from 'react-loader'
// import config from 'config'
import * as searchActions from 'redux/modules/search'
import {
  // TargetDateGrid,
  TargetDateLinks
} from '../../components'


@connect(
  state => ({
    result: state.fundsByStrategy.result,
    searching: state.fundsByStrategy.loading,
    searched: state.fundsByStrategy.loaded,
    error: state.fundsByStrategy.error
  }),
  searchActions)
export default class FundTargetDateLinks extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
    // search: PropTypes.func,
    strategyName: PropTypes.string.isRequired
  }
  constructor(props){
    super(props)
    this.state = {}
  }
  //
  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.props.getFundsByStrategy([this.props.strategyName])
  }
  //
  render() {
    return <TargetDateLinks funds={this.props.result} strategyName={this.props.strategyName}/>
  }
}
